import { Navigate, Outlet, createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@volvo/vcdk-react';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { useFleetAccount } from '@/contexts/fleet-account/useFleetAccount';
import useLayout from '@/hooks/useLayout';

export const Route = createFileRoute('/_authenticated/_account/dashboard')({
  component: DashboardLayout,
  errorComponent: ErrorBoundary,
});

function DashboardLayout() {
  const { isLoading, fleetVerifiedUnits } = useFleetAccount();
  const { canShowDashboard } = useLayout({
    units: fleetVerifiedUnits,
    unitsLoading: isLoading,
  });

  // canShowDashboard is also false while still loading — wait for data before deciding to
  // redirect, otherwise every reload briefly reports false and bounces the user to /units.
  if (isLoading) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Spinner size="medium" />
      </div>
    );
  }

  if (!canShowDashboard) {
    return <Navigate to="/units" replace />;
  }

  return <Outlet />;
}
